import Request from 'utilities/Request';
import {stringify} from 'querystring';
import {CARD_PARTS} from 'app/CardConstants';

export const fetchStackById = (
  id,
  options = {
    parts: CARD_PARTS.join(','),
  }
) => Request.get(`/api/content/v2/stacks/${id}/cards?&${stringify(options)}`);

export const grantAccessToStack = (stackId, userIds, groupIds) => {
  const users = userIds.map(id => ({id, type: 'user'}));
  const groups = groupIds.map(id => ({id, type: 'group'}));
  return Request.post('/api/content/v1/share', {
    resources: [{type: 'page', id: stackId}],
    recipients: [...users, ...groups],
  });
};

export const hasStackAccess = (stackId, options) => {
  const opts = {userIds: [], groupIds: [], ...options};
  const params = {
    userIds: opts.userIds.join(','),
    groupIds: opts.groupIds.join(','),
  };

  return Request.get(
    `/api/content/v1/share/accesslist/filtered/page/${stackId}?${stringify(
      params
    )}`
  );
};

export const requestAccess = stackId =>
  Request.post(`/api/content/v1/pages/${stackId}/requestaccess`);

export const assignPowerUp = ({pageId, assignee}) =>
  Request.put(`/api/content/v1/pages/${pageId}/dashboard/install`, {
    pageId,
    assignee,
  });
